import { default as CommonTools } from '../utils/common'
import { mercator2lonLat, formatDegree, lonLat2Mercator, getDistance, lonLatCoordsToMc, throttleFunc } from '../utils/tools'
import { BOATS_MODEL_PATH, IMAGE_PATH } from '../const'
import { default as mapApp } from '@/map/init.js'
import request from '../../utils/request-common';
// import requestHistory from '../../utils/request-common';
/**
 * 船只生成管理
 */
export default class BoatsMapActions extends esmap.ESEventDispatcher {
    constructor(map) {
        super();

        this.map = map

        this.floor = null;
        this.modelLayer = null;
        this.imageLayer = null;

        this.boatsMarkerList = [];

        this.isInitComplete = false

        this.forecastLine = null;
        this.historyLine = null;
        this.currSelectedBoatId = null;
        this.boatMoveHistoryPoints = [];

        this.shipData = []
        this.rawShipData = null
        this.dynamicShipData = []
        // 方案1：
        // this.aisBoatsTempData = null; // 存储原始对象
        this.aisBoatsData = null; // 处理后的AIS船数据

        // 方案2：
        // AIS船只标注对象
        this.storeBoatsDataInTenMin = {
            startTime: null,
            endTime: null,
        };
        this.aisBoatsMarkerList = [];
        this.tenMinHandle = null;
        this.checkHandle = null;
        this.isNeedClearBoats = false;
        this.isLoadAisData = true;
        this.isLoadAisComplete = false;
        // AIS船历史轨迹点集
        this.aisBoatHistoryPoints = [];
        this.isLoadBoatHistoryComplete = false;
        this.historyLineOffset = -3.5;

        // 船气泡
        this.shipPopVueComponent = null
        this.shipPopMarker = null
        // 预测轨迹 气泡
        this.forecastPopVueComponent = null
        this.forecastPopMarker = null

        // 主航道范围点集
        this.mainRouteExtentCoords = null;
        this.reqBoatWaterHandle = null;
        this.loadBoatWaterThrottle = null;

        //主航道入口和防波堤断口点位
        this.mainChannelPoint = { x: 13145563.875487415, y: 4740370.2864655575, num: 0, name: '主航道入口' }
        this.breakwaterPoint = { x: 13147500.4526163, y: 4743919.347676746, num: 1, name: '防波堤断口' }
        this.breakwaterPopVueComponent = []
        this.breakwaterPopMarker = []
    }

    // 外部初始化
    init () {
        if (this.isInitComplete) {
            this.resetView()
            return
        }
        this._init()
        this.isInitComplete = true
        this.loadActionData()


    }

    // 内部首次初始化层对象至地图
    _init () {
        // 获取层
        this.floor = this.map.getBuildingById(0).getFloor(1);
        // layer name 都填上好对应交互名称(建议唯一)，方便以后全局查找层对象
        // 创建普通标注层
        this.imageLayer = this.floor.getOrCreateLayerByName('forecastLineImg', esmap.ESLayerType.IMAGE_MARKER)
        // 创建船只图片标注
        this.boatsImgLayer = this.floor.getOrCreateLayerByName('boatsImg', esmap.ESLayerType.IMAGE_MARKER)
        //创建模型标注层    
        this.modelLayer = this.floor.getOrCreateLayerByName('boats', esmap.ESLayerType.MODEL3D);
        //创建特效标注层
        // this.lineEffectLayer = new esmap.ESEffectTool.EffectLayer('boatsLine', esmap.ESLayer.EFFECT_MARKER);

        this.floor.addLayer(this.imageLayer);
        // esmap.ESEffectTool.addLayerToMap(this.lineEffectLayer);
    }
    // 重置视角
    resetView () {

    }

    // 加载当前交互模块基础配置数据
    loadActionData () {
        let self = this
        this.createBoatRouteLines();

        // 加载实时船只AIS数据
        this.loadRealTimeAIS();

        // 开发环境 加载模拟船只数据
        // esmap.ESJsonFileLoader('./assets/actions/boats-simu.json').then((data) => {
        //     self.shipData = data.boatMarkers
        //     // 取消加载模拟船只
        //     for (let obj of self.shipData) {
        //         self.setBoatMove(obj);
        //     }
        // })

        // 只有在主航道线范围内，才会请求数据
        // esmap.ESJsonFileLoader('./data/boats/sea-routes.json').then((data) => {
        //     // 获取主航道范围
        //     self.mainRouteExtentCoords = lonLatCoordsToMc(data.features[2].geometry.coordinates[0][0]);
        // })
        
        // 更新为整个航道都可以
        esmap.ESJsonFileLoader('./data/boats/all-water-area.json').then((data) => {
            // 获取主航道范围
            self.mainRouteExtentCoords = lonLatCoordsToMc(data.features[0].geometry.coordinates[0]);
        })
    }

    // 管理地图点击
    managerMapClick (e) {
        if (e._boatType && e._boatType === 'ship') {
            let modelMarker = e;
            if (e.nodeType == esmap.ESNodeType.IMAGE_MARKER) {
                modelMarker = e.parent;
            }
            if (!this.shipPopMarker)
                this.createShipPopMarker()

            // 先关闭所有展示的轨迹线
            this.hideBoatRoutes();

            // 气泡Marker选择取消
            for (let i = 0; i < this.boatsMarkerList.length; i++) {
                this.boatsMarkerList[i].isSelected = false
            }
            // 如果是AIS船只
            for (let key in this.aisBoatsMarkerList) {
                this.aisBoatsMarkerList[key].isSelected = false
            }

            // 清除ais缓存的历史轨迹数据
            this.aisBoatHistoryPoints.length = 0;

            // 设置船对应数据类型
            this.shipPopVueComponent.isRealTime = modelMarker.isRealTime;

            // 气泡数据传入
            for (let i = 0; i < this.shipData.length; i++) {
                if (this.shipData[i].id === modelMarker.ID) {
                    this.shipPopVueComponent.popData = this.shipData[i].information
                    this.shipPopVueComponent.popData.id = modelMarker.ID;
                }
            }
            // 如果是AIS船只
            if (this.aisBoatsMarkerList[e.ID]) {
                this.shipPopVueComponent.popData = this.aisBoatsMarkerList[modelMarker.ID]._bindData.information
                this.shipPopVueComponent.allPointsDis = this.aisBoatsMarkerList[modelMarker.ID]._bindData.allPointsDis;
                this.shipPopVueComponent.popData.id = modelMarker.ID;
            }

            let tempAry = this.coordChange(modelMarker.mapCoord.x, modelMarker.mapCoord.y)
            this.shipPopVueComponent.longitude = tempAry[0]
            this.shipPopVueComponent.latitude = tempAry[1]

            modelMarker.isSelected = true
            this.currSelectedBoatId = modelMarker.ID;

            // 判断目标是否移动
            if (modelMarker.isMoving) {
                // console.log("is moving", e);
                this.shipPopVueComponent.routeBtnSign = true
                this.shipPopVueComponent.isShowForecast = true
                if (!modelMarker.isRealTime) { // TODO: 实时船只暂时关闭预测路线更新
                    this.updateBoatMoveForecastLine(modelMarker.ID)
                }
                // this.updateBoatMoveHistoryLine(e.movePoints);
            } else {
                this.shipPopVueComponent.routeBtnSign = false
            }
            this.updateShipPopMarker(modelMarker.mapCoord);
            this.clickBoatFocusView(modelMarker.mapCoord);

            // 清除船只水文数据数据
            this.clearShipPopData();
            // 请求获取船只水文数据
            this.loadRouteExtentBoatWaterData(modelMarker, this);

            this.loadBoatWaterThrottle = null;
            this.loadBoatWaterThrottle = throttleFunc(this.loadRouteExtentBoatWaterData, 100, 500, modelMarker, this);
        }

        if (e.name && e.name === 'forecastPoints') {
            if (!this.forecastPopMarker)
                this.createForecastPopMarker()

            this.updateForecastPopMarker(e.opts_);
        }

        // this.testLoadBoatWaterData(e.hitCoord);
    }

    /**
   * 创建船路线标注
   */
    createBoatRouteLines () {
        this.forecastLine = CommonTools.addNavLineMarker({
            id: "forecast_route",
            color: "#01ebff",
            lineWidth: 4,
            points: [],
            fixedWidth: true,
            alpha: 0.5,
            transparent: true,
        })
        this.forecastLine.visible = false;
        this.map.drawLineMark(this.forecastLine);

        this.historyLine = CommonTools.addNavLineMarker({
            id: "history_route",
            color: "#00ff00",
            lineWidth: 4,
            points: [],
            fixedWidth: true,
            alpha: 0.2,
            transparent: true,
            lineType: esmap.ESLineType.ARROW,
        })
        this.historyLine.visible = false;
        this.map.drawLineMark(this.historyLine);
    }

    // 点击船只飞行聚焦
    clickBoatFocusView (coord) {
        let self = this;
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            "directionAngle": 328.76, "pitchAngle": 60.79, "radius": 215,
            "x": coord.x,
            "y": coord.y,
            "z": 0,
            time: 2,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = false
                self.map.selectModelNull();
            }
        })
    }

    // 获取船舶接口数据
    async loadRealTimeAIS () {
        let self = this
        try {
            if (self.checkHandle) {
                // 取消定时器
                clearInterval(self.checkHandle);
                self.checkHandle = null;
            }
            // const { data } = await request('fn/ais')
            const { data } = await request('fn/aisMove')
            // console.log('boats:', data);

            // 数据时间范围:起始时间、结束时间、持续时间
            let startDateStr = this.getFullDateStr(data.date, data.timeRange.startTime)
            let endDateStr = this.getFullDateStr(data.date, data.timeRange.endTime)
            let extentTime = new Date(endDateStr).getTime() - new Date(startDateStr).getTime()
            // console.log("船舶历史轨迹数据时长:",extentTime/1000,"s");
            // 更新船舶数据
            self.updateBoatsDataEachSecond(extentTime, startDateStr, data.data.shipRoutes);
            self.isLoadAisComplete = true;

            // 如果已经展示了船只历史轨迹，则需要更新历史数据
            if (self.historyLine.visible && self.currSelectedBoatId) {
                self.loadRealTimeBoatTrack(self.currSelectedBoatId);
            }

            // 检测当前时间加载数据方案
            // self.storeBoatsDataInTenMin.endTime = new Date(endDateStr);
            // self.checkCurrTimeIsOutOfRange(extentTime)
            self.checkHandle = setInterval(() => {
                console.log('page visible status:', self.isLoadAisData)
                if (self.isLoadAisData) {
                    self.loadRealTimeAIS();
                }
            }, 60000);

            // 需要业务层指定什么时候清除哪些船只模型的
            // setTimeout(() => {
            //     if(this.isNeedClearBoats) {
            //         this.checkNeedClearBoatMarker(data.data.shipRoutes);
            //     }
            //     this.isNeedClearBoats = true;
            // }, 2000)
        } catch (err) {
            console.log('获取数据失败！', err)
        }
    }

    // 获取船舶接口数据
    async loadRealTimeBoatTrack (id) {
        let self = this
        try {
            const { data } = await request('fn/aisTrack', { MMSI: id, minute: 30 });
            console.log('track:', data.data);
            if (data.data && data.data.route) {
                let list = [];
                for (let i = 0, len = data.data.route.length; i < len; i++) {
                    let mc = lonLat2Mercator(data.data.route[i].fLong, data.data.route[i].fLat);
                    let coord = { x: mc[0], y: mc[1], offset: self.historyLineOffset, recordTime: data.data.route[i].recordTime };
                    list.push(coord);
                }
                self.aisBoatHistoryPoints = list; // 这里的历史数据点会超出，需要对数据进行裁剪处理
                // self.historyLine.updatePoints(list);

                if (self.currSelectedBoatId == id) {
                    let currHistoryPoints = self.cullRealTimeBoatHistoryData(self.aisBoatsMarkerList[id]._bindData, 1);
                    console.log('stop boat cull points', currHistoryPoints)
                    if (currHistoryPoints) {
                        self.historyLine.updatePoints(currHistoryPoints);
                    }
                }

                self.isLoadBoatHistoryComplete = true;
            }
        } catch (err) {
            console.log('获取数据失败！', err)
        }
    }

    // 检查当前时刻是否在以上一次请求差
    checkCurrTimeIsOutOfRange (extentTime) {
        if (this.checkHandle) {
            clearInterval(this.checkHandle);
            this.checkHandle = null;
        }
        this.checkHandle = setInterval(() => {
            if (this.storeBoatsDataInTenMin.endTime) {
                let deltaTime = new Date().getTime() - this.storeBoatsDataInTenMin.endTime.getTime();
                if (deltaTime >= extentTime) {
                    if (this.isLoadAisData) {
                        this.loadRealTimeAIS();
                    }
                }
            }
        }, 1000);
    }

    // 获取完整的日期格式字符串
    getFullDateStr (dateStr, timeStr) {
        return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)} ${timeStr}`
    }

    ////////////////////////////////
    ///  方案2：使用定时器每秒分发船只位置坐标点，使用moveTo更新即可
    ////////////////////////////////

    /**
     * 根据当前请求数据时间范围, 每秒更新船只数据一次
     */
    updateBoatsDataEachSecond (extentTime, startDateStr, shipRoutes) {
        let count = 0;
        let startDate = new Date(startDateStr);
        if (this.tenMinHandle) {
            clearInterval(this.tenMinHandle);
            this.tenMinHandle = null;
            count = 0;
        }
        // 定义一个定时器，extentTime默认是60000毫秒,超过时间清除
        this.tenMinHandle = setInterval(() => {
            if (count >= Math.ceil(extentTime / 1000)) {
                clearInterval(this.tenMinHandle);
                this.tenMinHandle = null;
                return;
            }
            count++;
            let result = {};
            for (let i = 0, len = shipRoutes.length; i < len; i++) {
                for (let j = 0, len2 = shipRoutes[i].route.length; j < len2; j++) {
                    let dateStr = `${shipRoutes[i].route[j].recordTime.substring(0, 10)} ${shipRoutes[i].route[j].recordTime.substring(11, 19)}`;
                    let secDiff = (new Date(dateStr).getTime() - startDate.getTime()) / 1000
                    let moveTime = 1; // 最短为一秒
                    // 轨迹点和计数器时间吻合，触发更新
                    if (secDiff == count) {
                        if (j > 0) {
                            // 每条船的运动时长不同，需要才上一次位置计算
                            let lastDateStr = `${shipRoutes[i].route[j - 1].recordTime.substring(0, 10)} ${shipRoutes[i].route[j - 1].recordTime.substring(11, 19)}`;
                            moveTime = (new Date(dateStr).getTime() - new Date(lastDateStr).getTime()) / 1000;
                        }
                        result[shipRoutes[i].shipulMMSI] = {
                            index: i, // 记录当前数组下标，用于历史需要移动的历史轨迹点位更新
                            lon: shipRoutes[i].route[j].fLong,
                            lat: shipRoutes[i].route[j].fLat,
                            angle: shipRoutes[i].route[j].COG, // FIXME: 这里需要提供对地航向（船只初始化朝向使用）
                            time: moveTime,
                            recordTime: shipRoutes[i].route[j].recordTime,
                            information: shipRoutes[i].staticMsg[0], // 信息
                        }
                        break;
                    }
                }
            }
            // console.log("处理数据后发送结果：", result);
            this.setRealTimeBoatMove(result);
        }, 1000);
    }

    // 监测当前需要移除的船标注
    checkNeedClearBoatMarker (shipRoutes) {
        let sameSet = new Set();
        let addSet = new Set();
        for (let i = 0, len = shipRoutes.length; i < len; i++) {
            if (this.aisBoatsMarkerList[shipRoutes[i].shipulMMSI]) {
                sameSet.add(shipRoutes[i].shipulMMSI)
            } else {
                addSet.add(shipRoutes[i].shipulMMSI);
            }
        }
        let removeList = {}; // 记录不再更新的car key
        for (let key in this.aisBoatsMarkerList) {
            if (!sameSet.has(key) && !addSet.has(key)) {
                removeList[key] = this.aisBoatsMarkerList[key];
            }
        }
        // console.log('需要删除的船只：', removeList);
        this.removeCarMarker(removeList) // 清除历史车辆
    }

    // 清除历史船只
    removeCarMarker (removeList) {
        for (let key in removeList) {
            if (removeList[key]._bindImgMarker) removeList[key]._bindImgMarker.dispose();
            removeList[key]._bindImgMarker = null;
            removeList[key].delete();
            delete this.aisBoatsMarkerList[key];
        }
    }

    // 根据船舶类型返回船舶模型URL
    getBoatModelByType(shipType){
        // 默认小型渔船
        let url = "/chuan-03/chuan-03.gltf"
        // 中型渔船
        if(shipType == 30){
            url = "/chuan-02/chuan-02.gltf"
        }else if(shipType == 33){
            // 疏浚船使用自有散货船模型
            url = "/chuan-01/chuan-01.gltf"
        }else if(shipType == 31 || shipType == 32){
            // 拖船
            url = "/tuochuan-1/tuochuan-1.gltf"
        }else if(shipType == 70){
            // 自有散货船
            url = "/zongheng-101/zongheng-101.gltf"
        }else if(shipType == 55){
            // 执法船
            url = "/haishichuan-1/haishichuan-1.gltf"
        }else{}
        return url
    }

    // 设置实时的船只移动
    setRealTimeBoatMove (boatsData) {
        // key是船舶MMSI
        for (let key in boatsData) {
            // let isInView = this.map.isCoordInView({ x:car.coord.x, y:car.coord.y })
            let mc = lonLat2Mercator(boatsData[key].lon, boatsData[key].lat);
            let coord = { x: mc[0], y: mc[1] };
            let boatName = boatsData[key].information && boatsData[key].information['Name'] ? boatsData[key].information['Name'].trim() : ''
            let boatSegauge = boatsData[key].information && boatsData[key].information['Seagauge'] ? boatsData[key].information['Seagauge'] : 0;
            if (this.aisBoatsMarkerList[key]) { // 对已有船舶进行moveTo移动
                let lastPos = this.aisBoatsMarkerList[key].mapCoord;
                let distance = getDistance(lastPos, coord);
                this.aisBoatsMarkerList[key]._bindData.allPointsDis += distance;
                this.aisBoatsMarkerList[key]._bindData.recordTime = boatsData[key].recordTime;
                if (distance > 4) { // TODO: 这里可判断更新点与上一点比较距离，大于一定范围则更新位置（不建议采用这种判断，从数据源控制车辆更新可更灵活修正，并且性能更好）
                    // console.log(boatName, boatsData[key].time, distance);
                    if (this.aisBoatsMarkerList[key].showLevel <= mapApp.map.zoomLevel) {
                        this.aisBoatsMarkerList[key].visible = true;
                    }
                    this.boatMoveTo(this.aisBoatsMarkerList[key], {
                        x: coord.x,
                        y: coord.y,
                        angle: 180, // 经测试数据提供的角度有问题，则这里的angle直接使用了moveTo点到点的自动方向校正
                        time: boatsData[key].time,
                        recordTime: boatsData[key].recordTime,
                    })
                } else {
                    // TODO: 统计小于指定间隔的点集
                    // if(!window.testBoatCoordObjs) window.testBoatCoordObjs = {}
                    // if(!window.testBoatCoordObjs[key]) window.testBoatCoordObjs[key] = {}
                    // if(!window.testBoatCoordObjs[key].disList){
                    //     window.testBoatCoordObjs[key].disList = [distance];
                    // }else{
                    //     window.testBoatCoordObjs[key].disList.push(distance);
                    // }
                }
            } else { // 新增
                // 定义模型数据对象
                let longAry = formatDegree(boatsData[key].lon)
                let latAry = formatDegree(boatsData[key].lat)
                let boatColorList = ['#f44336', '#ff9800']
                // 船舶类型
                let shipType = boatsData[key].information.ShipType ? boatsData[key].information.ShipType : 0
                // 船舶尺寸,商业散货船设置为0.5
                let shipSize = shipType == 70 ? 0.5 : 1
                // 默认使用小型渔船
                let url = this.getBoatModelByType(shipType)
                let tempObj = {
                    ID: key,
                    name: boatName,
                    movePoints: null,
                    url,
                    size: shipSize,
                    angle: 180 + boatsData[key].angle,
                    speed: 6,
                    offsetHeight: 1.5,
                    x: coord.x,
                    y: coord.y,
                    allPointsDis: 0,
                    information: {
                        "name": boatName,
                        "MMSI": key,
                        "WH": "67米/12米",
                        "IMO": 100,
                        "seagauge": boatSegauge,
                        "fLong": `${longAry[0]}°${longAry[1]}'${longAry[2]}"`,
                        "fLat": `${latAry[0]}°${latAry[1]}'${latAry[2]}"`,
                        "COG": boatsData[key].angle + "°",
                        "HDT": "78.5°",
                    },
                    color: boatColorList[1],
                    recordTime: boatsData[key].recordTime,
                }
                this.addBoatMarker(tempObj)
            }
        }
        // console.log("boatNum:", this.modelLayer.o3d_.children.length);
    }

    // 添加船标注
    addBoatMarker (data) {
        let boatMarker = CommonTools.addModelMarker({
            id: data.ID || data.id,
            name: data.name || data.Name,
            x: data.x,
            y: data.y,
            offsetHeight: data.offsetHeight,
            url: BOATS_MODEL_PATH + data.url,
            size: data.size,
            angle: data.angle,
            showLevel: 15,
            callback: (marker) => {
                data.x = marker.mapCoord.x;
                data.y = marker.mapCoord.y;
                data.callback = function (im) { // 防止异步导致加载位置出错
                    marker.addMarker(im);
                }
                this.addBoatImgMarker(data); // 用作远离模型后显示
            }
        })
        boatMarker._boatType = 'ship';
        boatMarker.isRealTime = true;
        boatMarker.isSelected = false
        if (data.codeImgOffset) {
            boatMarker.codeImgOffset = data.codeImgOffset;
        }
        boatMarker._bindData = data;
        this.aisBoatsMarkerList[data.ID] = boatMarker;
        // boatMarker._bindImgMarker = imgMarker; // 将标注绑定至船标注对象，方便调用
        // this.boatsImgLayer.addMarker(imgMarker);
        this.modelLayer.addMarker(boatMarker)
    }

    // 添加船图标
    addBoatImgMarker (data) {
        let marker = CommonTools.addImageMarker({
            id: data.ID,
            bid: 0,
            url: IMAGE_PATH + 'boat-3.png',
            name: data.name,
            x: data.x,
            y: data.y,
            offsetHeight: data.offsetHeight,
            up: false,
            angle: 0,
            // size: { w: 25, h: 50 },
            size: 50,
            showLevel: [8, 16],
            seeThrough: true,
            callback: (e) => {
                data.callback && data.callback(e);
            }
        })
        marker._boatType = 'ship';
        marker.setColor(data.color)
        return marker;
    }

    // 更新船图标位置
    updateBoatImgMarker (marker, coord) {
        marker.moveTo({
            x: coord.x,
            y: coord.y,
            time: 0
        })
    }

    // 切换显示船图片标注
    toggleBoatsImgMarker (level) {
        if (this.boatsImgLayer) {
            this.boatsImgLayer.visible = level <= 15;
        }
    }

    // 船点到点的移动
    boatMoveTo (marker, configs) {
        let self = this;
        // let historyLineOffset = -5;
        marker.showBoatFoam({ isShow: true, speed: 4 * 0.05 });
        let currHistoryPoints = null;
        if (this.isLoadBoatHistoryComplete && marker.isSelected) {
            currHistoryPoints = this.cullRealTimeBoatHistoryData(configs);
        }
        marker.moveTo({
            x: configs.x,
            y: configs.y,
            orientToPath: true,
            angle: configs.angle,
            time: configs.time,
            threshold: { // 转角偏移限定
                distance: 2, // 在当前范围（m）内的位置更新才受约束
                forward: [0, 90], // 向前更新受限角度范围
                backward: [90, 270] // 向后更新受限角度范围
            },
            onMoving: (e) => { // TODO: 待添加船身的上下起伏（正弦函数）
                // console.log(e)
                marker.isMoving = true;
                if (marker.markers && marker.markers.length > 0) {
                    marker.markers[0].setColor('#f44336');
                }
                if (this.shipPopMarker && marker.isSelected) {
                    this.updateShipPopMarker(e.position)
                    let tempAry = this.coordChange(e.position.x, e.position.y)
                    this.shipPopVueComponent.longitude = tempAry[0]
                    this.shipPopVueComponent.latitude = tempAry[1]
                    // console.log("move:", currHistoryPoints)
                    if (this.historyLine.visible) {
                        this.updateRealTimeBoatHistoryLine(currHistoryPoints, e.position, this.historyLineOffset);
                    }
                    if (self.loadBoatWaterThrottle) self.loadBoatWaterThrottle();
                }
                marker.moveingCoods = e.position;
            },
            callback: () => { // moveTo完成事件
                marker.isMoving = false;
                marker.showBoatFoam({ isShow: false });
                if (marker.markers && marker.markers.length > 0) {
                    marker.markers[0].setColor('#ff9800');
                }
            }
        });
    }

    // 裁剪实时船只历史轨迹数据
    cullRealTimeBoatHistoryData (data, offset) {
        let index = 0;
        for (let i = 0, len = this.aisBoatHistoryPoints.length; i < len; i++) {
            if (data.recordTime == this.aisBoatHistoryPoints[i].recordTime) {
                console.log('match point', data.recordTime, this.aisBoatHistoryPoints[i].recordTime)
                index = i;
                break;
            }
        }
        if (index > 0) {
            console.log("history index", index);
            if (offset) index += offset; // 修正点位
            return this.aisBoatHistoryPoints.slice(0, index);
        } else {
            console.warn("can not find match recordTime")
            return false
        }
    }

    // 显示隐藏AIS船只历史轨迹数据
    showRealTimeBoatHistoryLine (id, isShow) {
        if (isShow) {
            this.historyLine.visible = true;
            this.loadRealTimeBoatTrack(id);
        } else {
            this.historyLine.visible = false;
            this.isLoadBoatHistoryComplete = false;
        }
    }

    // 更新AIS船只历史轨迹线
    updateRealTimeBoatHistoryLine (list, coord, offset) {
        if (list && list.length > 1) {
            list[list.length - 1].x = coord.x,
                list[list.length - 1].y = coord.y,
                list[list.length - 1].offset = offset;
            this.historyLine.updatePoints(list);
        }
    }

    ////////////////////////////////////////////////////////////////
    /////  以下模块是模拟船只运动和相关业务逻辑
    ////////////////////////////////////////////////////////////////

    // 设置船移动【模拟船只】
    setBoatMove (data) {
        let self = this
        // console.log(data.Name);
        let boatMarker = CommonTools.addModelMarker({
            id: data.ID || data.id,
            name: data.name || data.Name,
            x: data.x,
            y: data.y,
            offsetHeight: data.offsetHeight,
            url: BOATS_MODEL_PATH + data.url,
            size: data.size,
            angle: data.angle,
            callback: function (marker) {
                if (data.movePoints && data.movePoints.length > 1) {
                    self.settingMoving({
                        data, marker
                    })
                }
            },
        })
        boatMarker._boatType = 'ship';
        boatMarker.isSelected = false;
        boatMarker.isRealTime = false;
        boatMarker._bindData = data;
        if (data.movePoints && data.movePoints.length > 1) {
            // boatMarker.speed = data.speed; // 将船速记录至marker对象中
            boatMarker.isMoving = true
            boatMarker.movePoints = JSON.parse(JSON.stringify(data.movePoints));
        }
        if (data.codeImgOffset) {
            boatMarker.codeImgOffset = data.codeImgOffset;
        }
        this.boatsMarkerList.push(boatMarker)
        this.modelLayer.addMarker(boatMarker)
    }

    // 设置船只按轨迹线运动
    settingMoving ({
        data,
        marker,
    }) {
        let self = this
        setTimeout(function () {
            // let count = 0; // 用于历史记录点计数
            marker.curDirection = 0; // 默认是正向移动
            marker.bindMoveConfig = marker.movePath({
                // 将配置绑定至marker对象中
                // time: data.time,
                speed: data.speed - 1, //速度
                loop: true, //是否循环
                loopReverse: true, // 是否反向循环
                path: data.movePoints, //路径点集
                startPathIndex: data.startIndex || 0, // 指定路径点集中的下标所对应的坐标作为运动起始位置
                minViewDistance: 20, // 设定跟随视角最小缩放距离
                maxViewDistance: 100, // 设定跟随视角最大缩放距离
                followPosition: false, //第一人称视角，跟随移动位置
                // followScaleLevel: 1, //第一人称视角，跟随缩放地图大小
                // viewTiltAngle: self.map.maxPolarAngle,//第一人称视角，地图俯仰角
                followAngle: false, //第一人称视角，根据路径来动态变换地图角度
                offsetHeight: data.offsetHeight + 4,
                orientToPath: true, //物体移动时是否沿向路径方向
                angle: data.angle, //物体移动沿向路径方向的角度
                complete: function () { },
                onMoving (e) { // TODO: 待添加船身的上下起伏（正弦函数）
                    // marker.o3d_.position.y += Math.random() * 0.1;
                    // console.log(123, self.boatsMarkerList, e)
                    if (self.shipPopMarker && marker.isSelected) {
                        self.updateShipPopMarker(e.position)

                        let tempAry = self.coordChange(e.position.x, e.position.y)
                        self.shipPopVueComponent.longitude = tempAry[0]
                        self.shipPopVueComponent.latitude = tempAry[1]

                        if (self.loadBoatWaterThrottle) self.loadBoatWaterThrottle();
                    }
                    marker.moveingCoods = e.position;

                    // TODO: 待处理预测轨迹和历史轨迹功能
                    // console.log(e.loopDirection);
                    if (e.loopDirection !== marker.curDirection) {
                        marker.curDirection = e.loopDirection;
                        if (self.historyLine.visible && self.historyLine.bindBoatId == marker.ID) self.historyLine.reverse();
                        if (self.forecastLine.visible && self.forecastLine.bindBoatId == marker.ID) self.forecastLine.reverse();
                    }
                    if (self.historyLine.visible && self.historyLine.bindBoatId == marker.ID) {
                        self.historyLine.splitAlpha({ percent: e.progress, isFront: false, alpha: 0 })
                    }
                    if (self.forecastLine.visible && self.forecastLine.bindBoatId == marker.ID) {
                        self.forecastLine.splitAlpha({ percent: e.progress, isFront: true, alpha: 0 })
                        self.toggleForecastLinePoints(e.progress);
                    }
                    //监听船舶行驶至主航道入口和防波堤断口显示气泡
                    // self.setBreakwaterPop()（气泡位置不对，暂时关闭）
                }
            })
        }, data.delayTime * 1000)
    }

    // 展示初始化完成的船只拖尾特效
    setBoatsFoamEffect (e) {
        if (this.boatsMarkerList.length > 0) {
            for (var i = 0; i < this.boatsMarkerList.length; i++) {
                if (e.id == this.boatsMarkerList[i].ID && this.boatsMarkerList[i].isMoving) {
                    this.boatsMarkerList[i].showBoatFoam({ isShow: true, speed: this.boatsMarkerList[i].speed * 0.05 });
                    break;
                }
            }
        }
    }

    // 根据id设置同种模型船身名称logo贴图偏移
    setBoatsCodeImg (e) {
        if (this.boatsMarkerList.length > 0) {
            for (var i = 0; i < this.boatsMarkerList.length; i++) {
                if (e.id == this.boatsMarkerList[i].ID) {
                    if (this.boatsMarkerList[i].codeImgOffset) {
                        this.boatsMarkerList[i].setUvTransform({ offset: { x: this.boatsMarkerList[i].codeImgOffset.x } });
                    }
                    break;
                }
            }
        }
    }

    // 获取船移动路径
    getBoatMovePath (id) {
        if (this.boatsMarkerList.length > 0) {
            for (var i = 0; i < this.boatsMarkerList.length; i++) {
                if (id == this.boatsMarkerList[i].ID) {
                    return this.boatsMarkerList[i].movePoints;
                }
            }
            return false;
        }
    }

    // 获取船在路线上的正反向
    getBoatMoveDirect (id) {
        if (this.boatsMarkerList.length > 0) {
            for (var i = 0; i < this.boatsMarkerList.length; i++) {
                if (id == this.boatsMarkerList[i].ID) {
                    return this.boatsMarkerList[i].curDirection;
                }
            }
        }
    }

    // 展示船预测路线
    updateBoatMoveForecastLine (id) {
        if (this.forecastLine.visible) {
            this.forecastLine.visible = false;
            this.imageLayer.removeAll();
            return;
        }
        // else {
        //   // 如果历史轨迹也展示过，则将历史轨迹隐藏
        //   this.historyLine.visible = false;
        // }
        let pathList = this.getBoatMovePath(id);
        if (!pathList) {
            console.warn('can not find boat move path!');
            return;
        }
        this.forecastLine.visible = true;
        this.forecastLine.bindBoatId = id;
        let list = []
        for (let i = 0; i < pathList.length; i++) {
            list.push({
                x: pathList[i].x, y: pathList[i].y, offset: pathList[i].offset - 1
            });
        }
        this.forecastLine.updatePoints(list);
        if (this.getBoatMoveDirect(id) == 1) { // 如果船是反转运动的状态
            this.forecastLine.reverse();
        }
        // 清空历史标记
        this.imageLayer.removeAll();
        if (!this.forecastLine.bindPointList) this.forecastLine.bindPointList = [];
        this.forecastLine.bindPointList.length = 0;
        this.createForecastLinePoints(pathList);
    }

    /**
     * 创建预测轨迹标点
     */
    createForecastLinePoints (pathList) {
        let gapDis = 300;
        let list = pathList;
        let lineLength = this.forecastLine.o3d_.children[0].length;
        let points = esmap.pointsSegement(list, gapDis);
        for (let i = 0; i < points.length; i++) {
            let pointProgress = (300 * (i + 1)) / lineLength;
            let marker = CommonTools.addImageMarker({
                id: 'forecast_' + i,
                bid: 0,
                url: './image/user.png',
                name: "forecastPoints",
                x: points[i].x,
                y: points[i].y,
                offsetHeight: 0.1,
                size: 100,
                seeThrough: true
            })
            marker.pointProgress = pointProgress;
            this.imageLayer.addMarker(marker);
            this.forecastLine.bindPointList.push(marker);
        }
    }

    /**
     * 根据当前船行驶路线进度控制显示标点
     */
    toggleForecastLinePoints (progress) {
        for (let marker of this.forecastLine.bindPointList) {
            if (marker.pointProgress > progress) {
                marker.visible = true;
            } else {
                marker.visible = false;
            }
        }
    }

    // 展示船历史轨迹
    updateBoatMoveHistoryLine (id) {
        if (this.historyLine.visible) {
            this.historyLine.visible = false;
            return;
        }
        // else {
        //   // 如果预测轨迹也展示过，则将预测轨迹隐藏
        //   this.forecastLine.visible = false;
        // }
        let pathList = this.getBoatMovePath(id);
        if (!pathList) {
            console.warn('can not find boat move path!');
            return;
        }
        this.historyLine.visible = true;
        this.historyLine.bindBoatId = id;
        let list = []
        for (let i = 0; i < pathList.length; i++) {
            list.push({
                x: pathList[i].x, y: pathList[i].y, offset: pathList[i].offset - 2
            });
        }
        this.historyLine.updatePoints(list);
        if (this.getBoatMoveDirect(id) == 1) { // 如果船是反转运动的状态
            this.historyLine.reverse();
        }
    }

    // 隐藏船只路线展示
    hideBoatRoutes () {
        if (this.historyLine && this.forecastLine) {
            this.historyLine.visible = false;
            this.forecastLine.visible = false;
            this.imageLayer.removeAll();
            // 关闭气泡中按钮的激活
            if (this.shipPopVueComponent) {
                this.shipPopVueComponent.isShowHistory = false;
                this.shipPopVueComponent.isShowForecast = false;
            }
        }
    }

    // 创建船只气泡标注
    createShipPopMarker () {
        let that = this
        this.shipPopMarker = CommonTools.addPopMarker({
            x: 13151625.988003284,
            y: 4750091.707444602,
            showLevel: 17
        })
        this.shipPopMarker.onUpdatePosition(function (transformStyle) {
            that.shipPopVueComponent.popTips.transformStyle = transformStyle
        })
    }

    // 更新船气泡位置
    updateShipPopMarker (data) {
        if (this.shipPopMarker) {
            this.shipPopMarker.moveTo({ x: data.x, y: data.y, time: 0 })
            this.shipPopVueComponent.popTips.visible = true
        }
    }

    // 关闭并移除船只气泡
    closeShipPop () {
        for (let i = 0; i < this.boatsMarkerList.length; i++) {
            this.boatsMarkerList[i].isSelected = false
        }
        for (let key in this.aisBoatsMarkerList) {
            this.aisBoatsMarkerList[key].isSelected = false;
        }
        if (this.shipPopMarker) {
            this.shipPopMarker.close()
            this.shipPopMarker = null
        }
        if (this.shipPopVueComponent) this.shipPopVueComponent.popTips.visible = false
        this.currSelectedBoatId = null; // 清除当前选中的船ID
        // this.historyLine.visible = false;
    }

    // 创建预测轨迹气泡标注
    createForecastPopMarker () {
        let that = this
        this.forecastPopMarker = CommonTools.addPopMarker({
            x: 13151625.988003284,
            y: 4750091.707444602
        })
        this.forecastPopMarker.onUpdatePosition(function (transformStyle) {
            that.forecastPopVueComponent.popTips.transformStyle = transformStyle
        })
    }
    // 更新预测轨迹气泡标注位置
    updateForecastPopMarker (data) {
        if (this.forecastPopMarker) {
            this.forecastPopMarker.moveTo({ x: data.x, y: data.y, time: 0 })
            this.forecastPopVueComponent.popTips.visible = true
        }
    }
    // 关闭预测轨迹气泡标注
    closeForecastPop () {
        if (this.forecastPopMarker) {
            this.forecastPopMarker.close()
            this.forecastPopMarker = null
        }
        if (this.forecastPopVueComponent) this.forecastPopVueComponent.popTips.visible = false
    }

    // 经纬浮点数转换度分秒字符串
    coordChange (x, y) {
        let tempAry = mercator2lonLat(x, y)

        let longAry = formatDegree(tempAry[0])
        let longString = `${longAry[0]}°${longAry[1]}'${longAry[2]}"`

        let latAry = formatDegree(tempAry[1])
        let latString = `${latAry[0]}°${latAry[1]}'${latAry[2]}"`

        return [longString, latString]
    }

    // 加载主航道范围船只水文数据
    async loadRouteExtentBoatWaterData (marker, context) {
        let self = context;
        let isInArea = esmap.ESMapUtil.pointInArea(marker.mapCoord, self.mainRouteExtentCoords);
        if (isInArea) {
            // console.log('in area:', marker.name);
            try {
                let lonLat = mercator2lonLat(marker.mapCoord.x, marker.mapCoord.y);
                const { data } = await request('fn/channelHydro', { lon: lonLat[0], lat: lonLat[1], draft: marker._bindData.information.seagauge });
                // console.log('boat water:', data);
                if (self.shipPopVueComponent && Object.keys(data.data).length > 0) {
                    self.shipPopVueComponent.popData.dire = data.data.dire;
                    self.shipPopVueComponent.popData.tidalLevel = data.data.tidalLevel;
                    self.shipPopVueComponent.popData.ukc = data.data.ukc;
                    self.shipPopVueComponent.popData.velo = data.data.velo;
                } else {
                    self.clearShipPopData();
                }
            } catch (err) {
                console.log('获取数据失败！', err)
                self.clearShipPopData();
            }
        } else {
            // console.log('out area:', marker.name);
        }
    }

    // 清除船只弹窗历史数据
    clearShipPopData () {
        if (this.shipPopVueComponent) {
            this.shipPopVueComponent.popData.dire = '';
            this.shipPopVueComponent.popData.tidalLevel = '';
            this.shipPopVueComponent.popData.ukc = '';
            this.shipPopVueComponent.popData.velo = '';
        }
    }

    async testLoadBoatWaterData (coord) {
        try {
            let lonLat = mercator2lonLat(coord.x, coord.y);
            const { data } = await request('fn/channelHydro', { lon: lonLat[0], lat: lonLat[1] });
            console.log('boat water:', data);
        } catch (err) {
            console.log('获取数据失败！', err)
        }
    }

    //监听船舶行驶至主航道入口和防波堤断口显示气泡
    setBreakwaterPop () {
        this.boatsMarkerList.forEach(e => {
            if (e.moveingCoods) {
                const x = e.moveingCoods.x
                const y = e.moveingCoods.y
                if (this.mainChannelPoint.x - 60 < x && x < this.mainChannelPoint.x + 60) {
                    if (this.mainChannelPoint.y - 60 < y && y < this.mainChannelPoint.y + 60) {
                        if (!this.breakwaterPopMarker[this.mainChannelPoint.num]) {
                            this.createBreakwaterPopMarker(this.mainChannelPoint)
                        }
                    }
                }
                if (this.breakwaterPoint.x - 60 < x && x < this.breakwaterPoint.x + 60) {
                    if (this.breakwaterPoint.y - 60 < y && y < this.breakwaterPoint.y + 60) {
                        if (!this.breakwaterPopMarker[this.breakwaterPoint.num]) {
                            this.createBreakwaterPopMarker(this.breakwaterPoint)
                        }
                    }
                }
            }
        })
    }

    // 创建主航道入口和防波堤断口气泡
    createBreakwaterPopMarker (coord) {
        let that = this
        this.breakwaterPopMarker[coord.num] = CommonTools.addPopMarker({
            x: coord.x,
            y: coord.y,
            showLevel: 17
        })
        this.breakwaterPopVueComponent[coord.num].popTips.visible = true
        this.breakwaterPopMarker[coord.num].onUpdatePosition(function (transformStyle) {
            that.breakwaterPopVueComponent[coord.num].popTips.transformStyle = transformStyle
        })
        //先创建popMarker再请求数据
        this.requestBreakwaterData(coord)

        //延时之后关闭弹窗
        setTimeout(() => {
            this.closeBreakwaterPop(coord.num)
        }, 15000);
    }
    //触发主航道和防波堤断口气泡事件
    async requestBreakwaterData (coord) {
        const lonLat = mercator2lonLat(coord.x, coord.y)
        const { data } = await request('fn/gridHydro', { lon: lonLat[0], lat: lonLat[1] })
        if (data.water_power) {
            this.breakwaterPopVueComponent[coord.num].popData = { ...data, ...coord, time: data.timeStamp.slice(0, 19).replace('T', ' ') }
        }
    }
    // 关闭主航道入口和断口气泡标注
    closeBreakwaterPop (num) {
        if (this.breakwaterPopMarker[num]) {
            this.breakwaterPopMarker[num].close()
            this.breakwaterPopMarker[num] = null
        }
        if (this.breakwaterPopVueComponent[num].popTips.visible) this.breakwaterPopVueComponent[num].popTips.visible = false
    }
}
